/* Approved Celitix WhatsApp templates available for manual sending — must stay
   in sync with backend util/whatsapp.js WHATSAPP_TEMPLATES (manual: true ones).

   Every template starts with "પ્રિય {{1}}," — the backend fills {{1}} with each
   recipient's name automatically, so `fields` only lists the remaining params.

   The "ads" template is system-only: it is sent automatically when an ad
   payment succeeds, so it is intentionally NOT listed here. */
export type WhatsAppTemplate = {
    name: string;
    label: string;
    /* labels for the manually-entered params ({{2}} onwards) */
    fields: string[];
};

export const WHATSAPP_TEMPLATES: WhatsAppTemplate[] = [
    { name: "update", label: "Update App", fields: [] },
    {
        name: "event",
        label: "New Event",
        fields: ["Event name", "Event date", "Event venue"],
    },
    { name: "new_business_aaded", label: "New Business Added", fields: [] },
];
